// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import SubHeaderCarousel from "./SubHeaderCarousel";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
  isSeo: boolean;
  showSearchForm?: boolean;
  isCarousel: boolean;
  isBackgroundFixed: boolean;
  showPriceSlider: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
  isSeo,
  showSearchForm = true, // Default a true se non specificato
  isCarousel,
  isBackgroundFixed
}) => {
  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;

  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  if (isCarousel) {
    return <SubHeaderCarousel agencyName={agency.agencyName} />;
  }
  if (isBackgroundFixed) {
    return (
      <section
        className="banner bg-holder bg-overlay-black-20"
        style={{ backgroundImage: 'url(/assets/images/bg-homeHero.jpg)' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              {isSeo ? (
                <h1 className="text-white text-center mb-2 asH1Title">{agency.agencyName}</h1>
              ) : (
                <h2 className="text-white text-center mb-2">{agency.agencyName}</h2>
              )}
              <p className="lead text-center text-white mb-4 font-weight-normal">
                {t('homePage.heroTitle')}
              </p>
              {showSearchForm && <PropertySearchField searchData={{}} showPriceSlider />}
            </div>
          </div>
        </div>
      </section>
    )
  }
  // Se tutte le condizioni sono false ritorna null
  return null;
};

export default SubHeaderHome;